import React from "react";
import { Link } from "react-router-dom";

export default function AboutUs() {
  return (
    <section className="bg-white py-10 sm:py-16 font-poppins">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        {/* Title */}
        <div className="flex justify-center mb-6 sm:mb-8">
          <h2
            className="text-xl sm:text-4xl font-extrabold text-white px-8 sm:px-12 py-3 rounded-md tracking-widest"
            style={{ backgroundColor: "#0F1030" }}
          >
            ABOUT US
          </h2>
        </div>

        {/* Bordered content box */}
        <div className="border border-gray-300 rounded-xl p-5 sm:p-8 mb-6">
          <p className="text-gray-700 text-sm leading-relaxed mb-6 text-center sm:text-left">
            SMARTCOOL AIR CONDITIONING CO. SMC LTD is a vertically integrated and fully registered
            Ugandan company headquartered in Kampala, providing world-class Heating, Ventilation,
            and Air Conditioning (HVAC) services across Uganda. We are a true full-service HVAC
            company — covering design, equipment supply, installation, maintenance, energy auditing,
            and technical consultancy all under one roof.
          </p>
          {/* <div className="flex justify-center gap-3 sm:gap-4">
            <button
              className="text-white font-semibold px-5 sm:px-6 py-2 rounded-md text-sm transition-colors hover:opacity-90"
              style={{ backgroundColor: "#0F1030" }}
            >
              Learn More
            </button>
            <button
              className="font-semibold px-5 sm:px-6 py-2 rounded-md text-sm transition-colors hover:opacity-80"
              style={{ border: "2px solid #0F1030", color: "#0F1030" }}
            >
              Contact Us
            </button>
          </div> */}

          <div className="flex justify-center gap-3 sm:gap-4">
            <Link
              to="/about"
              className="text-white font-semibold px-5 sm:px-6 py-2 rounded-md text-sm transition-colors hover:opacity-90 inline-block"
              style={{ backgroundColor: "#0F1030" }}
            >
              Learn More
            </Link>

            <Link
              to="/contact"
              className="font-semibold px-5 sm:px-6 py-2 rounded-md text-sm transition-colors hover:opacity-80 inline-block"
              style={{ border: "2px solid #0F1030", color: "#0F1030" }}
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3 sm:gap-6 pt-4">
          <div className="text-center">
            <p className="text-4xl sm:text-6xl font-extrabold font-anton" style={{ color: "#0F1030" }}>5+</p>
            <p className="font-bold text-gray-900 text-base sm:text-xl mt-1 sm:mt-2">Brands</p>
          </div>
          <div className="text-center flex flex-col items-center">
            <span className="text-3xl sm:text-5xl mb-1 sm:mb-2">📍</span>
            <p className="font-extrabold text-base sm:text-xl" style={{ color: "#0F1030" }}>Kampala, Uganda</p>
          </div>
          <div className="text-center">
            <p className="text-4xl sm:text-6xl font-extrabold font-anton" style={{ color: "#0F1030" }}>
              360<sup className="text-xl sm:text-3xl">°</sup>
            </p>
            <p className="font-bold text-gray-900 text-base sm:text-xl mt-1 sm:mt-2">HVAC Services</p>
          </div>
        </div>

      </div>
    </section>
  );
}